module.exports = __webpack_public_path__ + "static/media/new-year.a483d4ce.jpg";